import { ReactNode } from 'react'

import { motion } from 'framer-motion'
import {
  Text,
  GreyGrey90,
  Primary20SemiBold,
  Flex
} from '@sequencehq/core-components'
import { InvoiceWarningBanners } from 'Invoices/components/CreateEditShared'
import { INVOICE_TRANSITIONS } from 'Invoices/constants/animations'
import { CONTAINER_STYLES } from 'Invoices/constants'

type Props = {
  title: string
  children: ReactNode
  controls?: ReactNode
}

export const StepContainer = ({ title, children, controls }: Props) => {
  return (
    <>
      <Flex flex={1} flexDir="column" overflowY="auto">
        <motion.div
          key={title}
          {...INVOICE_TRANSITIONS.step}
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            zIndex: 1
          }}
        >
          <Flex
            flexDir="column"
            height="fit-content"
            width="100%"
            marginX="auto"
            {...CONTAINER_STYLES}
          >
            <InvoiceWarningBanners />

            <Text {...Primary20SemiBold} color={GreyGrey90}>
              {title}
            </Text>

            {children}
          </Flex>
        </motion.div>
      </Flex>

      {controls}
    </>
  )
}
